const Financial = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 20"
		fill="none"
		{...props}
	>
		<path
			stroke="#1E1E1E"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M10 4v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C11.536 10.219 10.768 10 10 10c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
		/>
	</svg>
);
export default Financial;
